// src/features/teamSectionSlice.js

import { createSlice } from '@reduxjs/toolkit';

const teamSectionSlice = createSlice({
  name: 'teamSection',
  initialState: {
    selectedState: null,
    activeChatLimit: false,
  },
  reducers: {
    setSelectedState: (state, action) => {
      state.selectedState = action.payload;
    },
    setActiveChatLimit: (state, action) => {
      state.activeChatLimit = action.payload;
    },
  },
});


export const { setSelectedState, setActiveChatLimit } = teamSectionSlice.actions;


export const selectSelectedState = (state) => state.teamSection.selectedState;
export const selectActiveChatLimit = (state) => state.teamSection.activeChatLimit;

export default teamSectionSlice.reducer;
